import TeacherApi from '@/api/teacher';

export default {
  namespaced: true,
  state: {
    allGroups: [],
    activeGroup: {},
    activeGroupLessons: [],
    activeGroupPastLessons: [],
    myUpcomingWebinars: [],
    homeworks: [],
  },
  mutations: {
    SET_ALL_GROUPS(state, val) {
      state.allGroups = val;
    },
    SET_ACTIVE_GROUP(state, val) {
      state.activeGroup = val;
    },
    SET_ACTIVE_GROUP_LESSONS(state, val) {
      state.activeGroupLessons = val;
    },
    SET_PAST_LESSONS(state, val) {
      state.activeGroupPastLessons = val;
    },
    SET_UPCOMING_WEBINARS(state, val) {
      state.myUpcomingWebinars = val;
    },
    SET_HOMEWORKS(state, val) {
      state.homeworks = val;
    },
    SET_WEBINAR(state, val) {
      let index = state.myUpcomingWebinars.findIndex(webinar => webinar.id === val.id)
      state.myUpcomingWebinars.splice(index, 1, val);
    },
    REMOVE_WEBINAR(state, val){
      let index = state.myUpcomingWebinars.findIndex(webinar => webinar.id === val.id)
      state.myUpcomingWebinars.splice(index, 1);
    }
  },
  getters: {
    pastLessonIds: (state) => state.activeGroupPastLessons.map((lesson) => lesson.id),
    activeHomeworks: (state) => state.homeworks.filter((homework) => homework.status === 0),
    oldHomeworks: (state) => state.homeworks.filter((homework) => homework.status !== 0),
  },
  actions: {
    async getAllGroups({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const allGroups = await TeacherApi.getGroups();
        if (allGroups.status === 200) {
          commit('SET_ALL_GROUPS', allGroups.data);
          return allGroups;
        }
        throw Error('Server Error With Groups');
      } catch (e) {
        throw e;
      }
    },
    // eslint-disable-next-line consistent-return
    async getGroupLessons({ commit }, data) {
      try {
        const allLessons = await TeacherApi.getLessons(data);
        if (allLessons.status === 200) {
          commit('SET_ACTIVE_GROUP_LESSONS', allLessons.data);
          return allLessons;
        }
      } catch (e) {
        throw e;
      }
    },
    async createNewWebinar({ commit }, data) {
      // eslint-disable-next-line no-useless-catch
      try {
        const newWebinar = await TeacherApi.scheduleWebinar(data);
        if (newWebinar.status === 200) {
          return newWebinar;
        }
      } catch (e) {
        throw e;
      }
    },
    async changeWebinar({commit}, data) {
      try {
        const changedWebinar = await TeacherApi.changeWebinar(data);
        if (changedWebinar.status === 200) {
          if (changedWebinar.data.is_past !== 3) {
            commit("SET_WEBINAR", changedWebinar.data)
          } else {
            commit("REMOVE_WEBINAR", changedWebinar.data)
          }
          return changedWebinar;
        }
      } catch (e) {
        throw e;
      }
    },
    async getWebinars({ commit }) {
      try {
        const myWebinars = await TeacherApi.getWebinars();
        if (myWebinars.status === 200) {
          commit('SET_UPCOMING_WEBINARS', myWebinars.data);
          return myWebinars;
        }
        throw new Error('webinars are not accessible');
      } catch (e) {
        throw e;
      }
    },
    async startWebinar({ dispatch }, id) {
      try {
        const webinarStart = await TeacherApi.startWebinar(id);
        if (webinarStart.status === 200) {
          dispatch('getWebinars');
          return webinarStart;
        }
      } catch (e) {
        throw e;
      }
    },
    async endWebinar({ dispatch }, id) {
      try {
        const webinarStart = await TeacherApi.endWebinar(id);
        if (webinarStart.status === 200) {
          dispatch('getWebinars');
          return webinarStart;
        }
      } catch (e) {
        throw e;
      }
    },
    async getHomeworks({ commit }) {
      try {
        const homeworks = await TeacherApi.getHomeworks();
        if (homeworks.status === 200) {
          commit('SET_HOMEWORKS', homeworks.data);
          return homeworks;
        }
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async evaluateHomeWork({ dispatch }, data) {
      try {
        const homework = await TeacherApi.evaluateHomeWork(data);
        if (homework.status === 200) {
          dispatch('getHomeworks');
          return homework;
        }
        throw new Error('can not evaluate homework');
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
};
